import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
export function PrintToolbar({
  title,
  onDownload,
}: {
  title: string;
  onDownload?: () => Promise<void>;
}) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
  return (
    <div className="dnm-print-toolbar">
      <span className="dnm-print-toolbar-title">{title}</span>
      <div className="dnm-print-toolbar-actions">
        <button type="button" className="dnm-print-secondary" onClick={() => window.print()}>
          {t('invoices.printToolbar.print')}
        </button>
        {onDownload && (
          <button
            type="button"
            className="dnm-print-primary"
            disabled={busy}
            aria-busy={busy}
            onClick={async () => {
              setBusy(true);
              setError(null);
              try {
                await onDownload();
              } catch {
                setError('Could not create PDF. Try again.');
              } finally {
                setBusy(false);
              }
            }}
          >
            {busy ? 'Preparing PDF…' : 'Download PDF'}
          </button>
        )}
      </div>
      {onDownload && (
        <span className="dnm-print-toolbar-guidance">{t('invoices.printToolbar.guidance')}</span>
      )}
      {error && (
        <span className="dnm-print-toolbar-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
